<template>
    <td v-if="spiel" :colspan="spielResult.showSVSpalte?3:2"
        :class="[{'white--text': isWinner && !isPrint},
                {'width160': $vuetify.breakpoint.smAndUp},
                {'width40perc': $vuetify.breakpoint.xsOnly},
                {'font12 py-2 text-left pl-2': isDoppel && !spiel[freilosKey] && !spiel[teamKey+'Empty']  && !isPrint},
                {'text-left pl-2 py-1': isDoppel && !spiel[freilosKey] && !spiel[teamKey+'Empty'] && isPrint},
                {'py-1': !isDoppel && !isOperator},
                {'pr-7': isOperator},
                 'lineHeightDense']"
        :style="styling">
        <span v-if="spiel[teamKey]?.settings?.name || spiel[freilosKey]">
            {{spiel[teamKey]?.settings?.name}} <span v-if="spiel[freilosKey]">FREILOS</span>
            <div v-if="isOperator" :class="isDoppel?'fixedIcon':'fixedIconSingle'">
                <v-btn @click="editTeam(teamKey, spiel[teamKey])" icon small :disabled="bewerbIsConfirmed">
                    <v-icon small :color="isWinner?'white':'primary'">mdi-pencil</v-icon>
                </v-btn>
            </div>
        </span>
        <span v-else>
            <span v-if="spiel[teamKey+'Empty']">{{spiel[teamKey+'Empty']}}</span>
            <v-btn v-if="isOperator" @click="editTeam(teamKey, spiel[teamKey])"
                           :disabled="bewerbIsConfirmed" text small color="primary">
            <v-icon small class="mr-1">mdi-plus</v-icon>
            {{ teamLabel.singular }}/Freilos
            </v-btn>
        </span>
        <div v-if="spiel[teamKey+'Status']!=='finished'" class="pt-1">
            <v-chip v-if="!isPrint" color="primary" small>
                {{resultStatus.find(status => status.value === spiel[teamKey+'Status'])?.label}}
            </v-chip>
            <span v-else class="primary--text">
                {{resultStatus.find(status => status.value === spiel[teamKey+'Status'])?.label}}
            </span>
        </div>
    </td>
</template>

<script>

import {RESULT_STATUS} from "@/services/data/meisterschaften/bewerb_constants";

export default {
    name: "spielKoTeam",
    props: ['teamKey', 'spielResult', 'spiel', 'teamLabel', 'bewerbIsConfirmed', 'isOperator', 'isPrint'],
    computed: {
        isWinner(){ return this.spiel?.winner === this.teamKey;},
        freilosKey() { return this.teamKey === 'team1' ? 'team1Freilos' : 'team2Freilos';},
        isDoppel(){
            return this.spiel?.[this.teamKey]?.settings?.name?.indexOf('/') !== -1;
        },
        styling(){
            return this.isPrint ?
                this.isWinner ?
                { position: 'relative', verticalAlign: 'top', border: '1px solid grey', color: 'green',
                    textDecoration: 'underline'} :
                { position: 'relative', verticalAlign: 'top', border: '1px solid grey' } :
                this.isWinner ?
                { position: 'relative', verticalAlign: 'top', border: '1px solid grey', backgroundColor: '#4caf50' } :
                { position: 'relative', verticalAlign: 'top', border: '1px solid grey', backgroundColor: 'white' }
        }
    },
    data: () => ({
        resultStatus: RESULT_STATUS
    }),
    methods: {
        editTeam(teamKey, team){
            this.$emit('editTeam', {team: team, spiel: {teamKey, spielData: this.spiel}});
        }
    },
}
</script>

<style scoped>
    .font12 {font-size: 12px;}
    .width160 {width: 160px;}
    .width40perc {width: 42%;}
    .fixedIcon {position: absolute; right: 6px; top: 6px;}
    .fixedIconSingle {position: absolute; right: 6px; top: 3px;}
    .lineHeightDense {line-height: 1.3; padding-top: 10px; padding-bottom: 8px}
</style>